import types from '../types';
import { uri } from 'utils';

/**
 * @typedef  {Object} Params
 * @property {string} url
 * @property {string} filterId
 * @property {types.FilterRadio} radio
 */

/**
 * @param {Params}
 * @returns {types.FilterRadio}
 */
export default function getRadioStateFromURL({ radio, url, filterId }) {
    const radioValueInURL = uri.getParams(url)[filterId];

    if (!radioValueInURL) {
        return {
            ...radio,
            checked: false
        };
    }

    return {
        ...radio,
        checked: true
    };
}
